import React from 'react';
import { Attribution } from '#components';
import { Container } from './SectionContainer.styles';

export const SectionContainer = ({ children }) => (
  <Container>
    {children}
    <div className="attribution">
      <Attribution />
    </div>
  </Container>
);
